import { combineReducers } from 'redux'
import shop from './shop.js'
import languages from './languages.js'
import themes from './themes.js'
import new_theme from './new_theme.js'
import static_theme from './static_theme.js'
import theme from './theme.js'
import pages from './pages.js'
import products from './products.js'
import collections from './collections.js'
import translatableResources from './translatableResources.js'
import blogs from './blogs.js'
import articles from './articles.js'
import navigation from './navigation.js'
import customContents from './customContents.js'
import newCustomContents from './newCustomContents.js'
import images from './images.js'
import notifications from './notifications.js'
import metaObjects from './metaObjects.js'
import appEmbeds from './appEmbeds.js'
import appIntegrations from './appIntegrations.js'
import partners from './partners.js'
import sizeChart from './sizeChart.js'
import search from './search.js'
import stats from './stats.js'
import markets from './markets.js'
import syncByShopifyId from './sync_by_shopify_id.js'
import switcherConfigurator from './switcherConfigurator.js'
import bulkTranslation from './bulkTranslation.js'
import langifyNotifications from './langifyNotifications.js'
import themeAppExtension from './themeAppExtension.js'
import plans from './plans.js'
import ticketsystem from './ticketsystem.js'
import wordslog from './wordslog.js'
import glossary from './glossary.js'
import config from './config.js'
import editing from './editing.js'

export default () => combineReducers({
  editing,
  shop,
  languages,
  themes,
  static_theme,
  new_theme,
  theme,
  customContents,
  newCustomContents,
  pages,
  products,
  collections,
  blogs,
  articles,
  navigation,
  images,
  markets,
  notifications,
  metaObjects,
  appEmbeds,
  appIntegrations,
  partners,
  sizeChart,
  search,
  stats,
  syncByShopifyId,
  switcherConfigurator,
  bulkTranslation,
  langifyNotifications,
  themeAppExtension,
  plans,
  ticketsystem,
  wordslog,
  glossary,
  config,
  translatableResources
})
